// extracted by css-extract-rspack-plugin
export default {"grid":"CollapsibleRegion-module__grid__acCOq","expanded":"CollapsibleRegion-module__expanded__foTs4","inner":"CollapsibleRegion-module__inner__Ly1nE"};